(() => {
  const KEY = "hyper-tech-compare";
  const MAX = 3;
  const comparePage = window.theme?.compareUrl || "/search?view=compare";

  const load = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  };
  const save = (items) => localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX)));

  function renderDock() {
    const dock = document.getElementById("CompareDock");
    if (!dock) return;
    const items = load();
    if (!items.length) {
      dock.hidden = true;
      dock.innerHTML = "";
      return;
    }
    dock.hidden = false;
    dock.innerHTML = `${items
      .map(
        (item) =>
          `<span class="compare-dock-item"><img src="${item.image || ""}" alt=""><span class="compare-dock-name">${escapeHtml(item.title)}</span><button type="button" class="compare-dock-remove" data-remove="${item.handle}" aria-label="Remove">×</button></span>`
      )
      .join("")}
      <a class="btn btn-primary" href="${comparePage}${comparePage.includes("?") ? "&" : "?"}devices=${encodeURIComponent(items.map((i) => i.handle).join(","))}">Compare ${items.length}</a>`;
    dock.querySelectorAll("[data-remove]").forEach((btn) => {
      btn.addEventListener("click", () => {
        save(load().filter((i) => i.handle !== btn.dataset.remove));
        renderDock();
      });
    });
  }

  let refreshBoard = null;

  window.hyperCompare = {
    add(product) {
      if (!product?.handle) return;
      const items = load().filter((i) => i.handle !== product.handle);
      if (items.length >= MAX) items.shift();
      items.push({
        handle: product.handle,
        title: product.title || product.handle,
        image: product.image || ""
      });
      save(items);
      renderDock();
      if (typeof refreshBoard === "function") refreshBoard();
    },
    load,
    save,
    max: MAX
  };

  document.addEventListener("click", (event) => {
    const btn = event.target.closest("[data-add-compare]");
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    window.hyperCompare.add({
      handle: btn.dataset.handle,
      title: btn.dataset.title,
      image: btn.dataset.image
    });
  });

  const board = document.querySelector("[data-compare-board]");
  if (board) {
    const params = new URLSearchParams(location.search);
    const fromUrl = (params.get("devices") || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    if (fromUrl.length) {
      save(fromUrl.map((handle) => ({ handle, title: handle })));
    }
    initBoard(board);
  }

  function parseJsonLoose(text) {
    const start = text.indexOf("{");
    const end = text.lastIndexOf("}");
    if (start === -1 || end === -1) throw new Error("No JSON object");
    return JSON.parse(text.slice(start, end + 1));
  }

  const SKIP_SPEC_KEYS = /^(category|specification|other|why choose|what.?s new|message|whatsapp|warranty|features|essential extras)$/i;
  const SKIP_SPEC_VALUES = /whatsapp|click here|\+592|messenger|free delivery/i;
  const SPEC_ORDER = [
    "Brand",
    "Type",
    "Model",
    "SKU / model",
    "Price",
    "Stock",
    "Heading",
    "Why buy",
    "Key features",
    "What's new",
    "Display",
    "Processor",
    "Graphics",
    "Memory",
    "Storage",
    "Memory & Storage",
    "Battery",
    "Charging",
    "Camera",
    "Rear Camera",
    "Front Camera",
    "OS",
    "OS & Software",
    "Connectivity",
    "Ports",
    "Audio",
    "Audio & Sensors",
    "Security & Sensors",
    "Dimensions",
    "Weight",
    "Dimensions & Weight",
    "Build & Durability",
    "Colors"
  ];

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function cleanText(value) {
    return String(value || "")
      .replace(/<br\s*\/?>/gi, " ")
      .replace(/<[^>]+>/g, " ")
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/g, "'")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalizeSpecKey(key) {
    const raw = cleanText(key).replace(/:$/, "");
    const map = {
      "memory & storage": "Memory & Storage",
      "os & software": "OS",
      "operating system": "OS",
      "dimensions & weight": "Dimensions & Weight",
      "build & durability": "Build & Durability",
      "audio & sensors": "Audio & Sensors",
      "sku": "SKU / model",
      "sku / model": "SKU / model",
      vendor: "Brand"
    };
    return map[raw.toLowerCase()] || raw;
  }

  const STORY_KEYS = ["Heading", "Why buy", "Key features", "What's new"];
  const COLLAPSE_KEYS = ["Why buy", "Key features", "What's new"];

  function parseStoryFromHtml(html) {
    const story = {};
    if (!html) return story;
    const doc = new DOMParser().parseFromString(`<div>${html}</div>`, "text/html");
    const blocks = [];

    function walk(el) {
      [...el.children].forEach((child) => {
        if (/^H[1-6]$/.test(child.tagName)) {
          blocks.push({ type: "h", text: cleanText(child.textContent) });
        } else if (child.tagName === "UL" || child.tagName === "OL") {
          const items = [...child.querySelectorAll("li")]
            .map((li) => "• " + cleanText(li.innerHTML))
            .filter((item) => item.length > 2);
          if (items.length) blocks.push({ type: "list", text: items.join("\n") });
        } else if (child.tagName === "P") {
          const text = cleanText(child.innerHTML);
          if (text && !/message us now|whatsapp or call|\+592-648/i.test(text)) {
            blocks.push({ type: "p", text });
          }
        } else if (child.tagName !== "TABLE") {
          walk(child);
        }
      });
    }
    walk(doc.body);

    let bucket = "";
    blocks.forEach((block) => {
      if (block.type === "h") {
        const title = block.text;
        if (/why (buy|choose)/i.test(title)) bucket = "Why buy";
        else if (/key features/i.test(title)) bucket = "Key features";
        else if (/what.?s new/i.test(title)) bucket = "What's new";
        else if (/detailed spec|message us|whatsapp/i.test(title)) bucket = "";
        else if (!story.Heading && title) {
          story.Heading = title;
          bucket = "";
        } else {
          bucket = "";
        }
        return;
      }
      if (!bucket) return;
      story[bucket] = story[bucket] ? `${story[bucket]}\n\n${block.text}` : block.text;
    });
    return story;
  }

  function parseSpecsFromHtml(html) {
    const specs = {};
    if (!html) return specs;
    const doc = new DOMParser().parseFromString(`<div>${html}</div>`, "text/html");
    doc.querySelectorAll("table tr").forEach((row) => {
      const cells = [...row.querySelectorAll("th,td")].map((cell) => cleanText(cell.innerHTML));
      if (cells.length < 2) return;
      const key = normalizeSpecKey(cells[0]);
      const value = cells.slice(1).join(" ").trim();
      if (!key || !value || SKIP_SPEC_KEYS.test(key) || SKIP_SPEC_VALUES.test(value)) return;
      specs[key] = value;
    });
    const lines = cleanText(doc.body.innerText || "")
      .split(/\n+|•|·|/)
      .map((line) => line.replace(/^[-–]\s*/, "").trim())
      .filter((line) => line.length > 8 && line.length < 160);
    lines.forEach((line) => {
      const key = classifySpecLine(line);
      if (!key || specs[key] || SKIP_SPEC_VALUES.test(line)) return;
      specs[key] = line.replace(/^(display|processor|battery|camera|storage|memory|os)\s*[:–-]\s*/i, "").trim();
    });
    return specs;
  }

  function classifySpecLine(line) {
    const l = line.toLowerCase();
    if (/display|retina|amoled|oled|ips lcd|hz/.test(l) && /(display|lcd|oled|retina|hz)/.test(l)) return "Display";
    if (/processor|bionic|snapdragon|helio|dimensity|unisoc|mediatek|intel core/.test(l)) return "Processor";
    if (/\bgb\b/.test(l) && /ram/.test(l) && /storage|ssd|rom/.test(l)) return "Memory & Storage";
    if (/rear camera|dual camera|mp/.test(l) && /camera|mp/.test(l) && /rear|dual|back/.test(l)) return "Rear Camera";
    if (/front camera|selfie/.test(l)) return "Front Camera";
    if (/battery|mah/.test(l)) return "Battery";
    if (/fast charg|\dw/.test(l) && /charg/.test(l)) return "Charging";
    if (/android|hyperos|ios|windows/.test(l)) return "OS";
    if (/face id|fingerprint/.test(l)) return "Security & Sensors";
    return "";
  }

  function formatPriceHtml(product) {
    const sale = product.price_label || "";
    const was = product.compare_at_price_label;
    const cap = Number(product.compare_at_price);
    const price = Number(product.price);
    if (was && cap > price) {
      return `<s class="price-compare">${escapeHtml(was)}</s> <span class="price-sale">${escapeHtml(sale)}</span>`;
    }
    return escapeHtml(sale);
  }

  function stockClass(label) {
    const v = String(label || "").toLowerCase();
    if (v.includes("out")) return "stock-sold";
    if (v.includes("low")) return "stock-note";
    if (v.includes("in stock")) return "stock-ok";
    return "";
  }

  function stockLabel(product) {
    if (product.available === false) return "Out of stock";
    const threshold = 3;
    const qty = Number(product.inventory_quantity);
    if (product.tracks_inventory) {
      if (!Number.isNaN(qty) && qty <= 0) return "Out of stock";
      if (!Number.isNaN(qty) && qty <= threshold) return "Low stock";
    }
    return "In stock";
  }

  function specsFromTitle(title) {
    const specs = {};
    const ram = title.match(/(\d+\s*GB)\s*RAM/i);
    const storage = title.match(/(\d+\s*GB|\d+\s*TB)\s*(SSD|storage)?/i);
    const screen = title.match(/(\d+(?:\.\d+)?)\s*(?:\"|inch)/i);
    if (ram) specs.Memory = ram[1].toUpperCase().replace("GB", " GB") + " RAM";
    if (storage) specs.Storage = storage[1].toUpperCase().replace("GB", " GB").replace("TB", " TB");
    if (screen) specs.Display = `${screen[1]}"`;
    return specs;
  }

  function enrichProduct(product) {
    const fromMeta = {};
    Object.entries(product.specs || {}).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== "") {
        fromMeta[normalizeSpecKey(key)] = String(value).trim();
      }
    });
    const fromHtml = parseSpecsFromHtml(product.description || "");
    const fromTitle = specsFromTitle(product.title || "");
    const fromStory = parseStoryFromHtml(product.description || "");
    product.specs = {
      Brand: product.vendor || fromMeta.Brand || "",
      Type: product.type || fromMeta.Type || "",
      Price: formatPriceHtml(product),
      Stock: stockLabel(product),
      ...fromTitle,
      ...fromHtml,
      ...fromMeta,
      ...fromStory
    };
    Object.keys(product.specs).forEach((key) => {
      if (!product.specs[key]) delete product.specs[key];
    });
    return product;
  }

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}?view=compare-data`);
    if (res.ok) {
      const text = await res.text();
      try {
        return enrichProduct(parseJsonLoose(text));
      } catch {
        /* fall through */
      }
    }
    const fallback = await fetch(`/products/${handle}.js`);
    const p = await fallback.json();
    const variant = (p.variants && p.variants[0]) || {};
    return enrichProduct({
      handle: p.handle,
      title: p.title,
      url: p.url,
      price: p.price,
      price_label: typeof window.themeMoney === "function" ? window.themeMoney(p.price) : "",
      compare_at_price: variant.compare_at_price,
      compare_at_price_label:
        variant.compare_at_price && variant.compare_at_price > p.price && typeof window.themeMoney === "function"
          ? window.themeMoney(variant.compare_at_price)
          : "",
      available: p.available,
      image: p.featured_image,
      vendor: p.vendor,
      type: p.type,
      description: p.description,
      specs: {
        Type: p.type || "",
        Brand: p.vendor || "",
        "SKU / model": variant.sku || ""
      }
    });
  }

  async function searchProducts(q) {
    if (window.themeSearch?.searchProducts) return window.themeSearch.searchProducts(q);
    const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][fields]=title,variants.sku,vendor`;
    const res = await fetch(url);
    const data = await res.json();
    return (((data || {}).resources || {}).results || {}).products || [];
  }

  function initBoard(root) {
    const slots = [...root.querySelectorAll("[data-slot]")];
    const tableHost = root.querySelector("[data-compare-table]");
    const state = [null, null, null];

    refreshBoard = async () => {
      const stored = load();
      tableHost.innerHTML = `<p class="empty">Loading devices…</p>`;
      for (let i = 0; i < MAX; i += 1) {
        const item = stored[i];
        if (!item?.handle || !slots[i]) {
          state[i] = null;
          paintSlot(slots[i], null);
          continue;
        }
        try {
          const product = await fetchProduct(item.handle);
          state[i] = product;
          paintSlot(slots[i], product);
        } catch (err) {
          console.warn("Compare load failed", item.handle, err);
        }
      }
      paintTable();
    };
    refreshBoard();

    function hideSlotResults() {
      slots.forEach((item) => {
        const panel = item.querySelector("[data-slot-results]");
        if (panel) {
          panel.hidden = true;
          panel.style.top = "";
          panel.style.maxHeight = "";
        }
      });
      document.body.classList.remove("compare-suggest-open");
    }

    // Desktop: the panel is absolutely positioned under its slot by CSS.
    // Mobile: the panel is fixed, so anchor it under the whole slot row and
    // size it to the remaining viewport so results can scroll.
    function placeResults(panel) {
      if (getComputedStyle(panel).position !== "fixed") {
        panel.style.top = "";
        panel.style.maxHeight = "";
        return;
      }
      const controls = root.querySelector(".compare-controls") || panel.parentElement;
      const vh = window.visualViewport?.height || window.innerHeight;
      const MIN_PANEL = 200;
      let anchor = controls.getBoundingClientRect();
      // If the slot row sits too low for a usable panel, scroll it up first.
      if (anchor.bottom + 8 + MIN_PANEL > vh && anchor.top > 72) {
        window.scrollBy({ top: Math.min(anchor.top - 72, anchor.bottom + 8 + MIN_PANEL - vh), behavior: "instant" });
        anchor = controls.getBoundingClientRect();
      }
      let top = anchor.bottom + 8;
      if (vh - top < MIN_PANEL) top = Math.max(8, vh - MIN_PANEL - 12);
      panel.style.top = `${Math.round(top)}px`;
      panel.style.maxHeight = `${Math.max(160, Math.round(vh - top - 12))}px`;
    }

    function clearSlot(index) {
      state[index] = null;
      const compact = state.filter(Boolean);
      for (let i = 0; i < MAX; i += 1) state[i] = compact[i] || null;
      save(compact.map((p) => ({ handle: p.handle, title: p.title, image: p.image })));
      slots.forEach((slot, i) => {
        paintSlot(slot, state[i]);
        const input = slot.querySelector("input");
        if (input) input.value = state[i] ? state[i].title : "";
      });
      hideSlotResults();
      paintTable();
      renderDock();
    }

    root.addEventListener("click", (event) => {
      const removeBtn = event.target.closest("[data-slot-remove]");
      if (removeBtn) {
        event.preventDefault();
        clearSlot(slots.indexOf(removeBtn.closest("[data-slot]")));
        return;
      }
      if (event.target.closest("[data-compare-clear]")) {
        event.preventDefault();
        for (let i = 0; i < MAX; i += 1) state[i] = null;
        clearSlot(0);
      }
    });

    document.addEventListener("click", (event) => {
      if (event.target.closest("[data-slot-results]")) return;
      if (event.target.closest("[data-slot] input")) return;
      hideSlotResults();
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") hideSlotResults();
    });
    window.addEventListener("resize", () => {
      slots.forEach((item) => {
        const panel = item.querySelector("[data-slot-results]");
        if (panel && !panel.hidden) placeResults(panel);
      });
    });

    slots.forEach((slot, index) => {
      const input = slot.querySelector("input");
      const results = slot.querySelector("[data-slot-results]");
      let timer = 0;
      input.addEventListener("input", () => {
        clearTimeout(timer);
        timer = setTimeout(async () => {
          const q = input.value.trim();
          if (!q) {
            hideSlotResults();
            return;
          }
          hideSlotResults();
          let products = [];
          try {
            products = await searchProducts(q);
          } catch (err) {
            results.innerHTML = `<div class="search-hit"><div></div><div><div class="title">Search failed</div></div></div>`;
            results.hidden = false;
            document.body.classList.add("compare-suggest-open");
            placeResults(results);
            return;
          }
          if (!products.length) {
            results.innerHTML = `<div class="search-hit"><div></div><div><div class="title">No matching model</div></div></div>`;
            results.hidden = false;
            document.body.classList.add("compare-suggest-open");
            placeResults(results);
            return;
          }
          results.innerHTML = products
            .map((p) => {
              const img = escapeHtml(p.image || "");
              const media = p.video_url
                ? `<video src="${escapeHtml(p.video_url)}" poster="${img}" autoplay muted loop playsinline></video>`
                : `<img src="${img}" alt="">`;
              return `<button type="button" class="search-hit" data-handle="${escapeHtml(p.handle)}" style="width:100%;text-align:left;background:transparent;border:0;cursor:pointer">
                  ${media}
                  <div><div class="title">${escapeHtml(p.title)}</div><div class="meta">${escapeHtml(p.vendor || "")}</div></div>
                </button>`;
            })
            .join("");
          results.hidden = false;
          document.body.classList.add("compare-suggest-open");
          placeResults(results);
          results.scrollTop = 0;
          results.querySelectorAll("video").forEach((video) => {
            video.muted = true;
            video.playsInline = true;
            video.play().catch(() => {});
          });
          results.querySelectorAll("[data-handle]").forEach((btn) => {
            btn.addEventListener("click", async () => {
              const product = await fetchProduct(btn.dataset.handle);
              state[index] = product;
              paintSlot(slot, product);
              const items = state.filter(Boolean).map((p) => ({ handle: p.handle, title: p.title, image: p.image }));
              save(items);
              results.hidden = true;
              document.body.classList.remove("compare-suggest-open");
              input.value = product.title;
              paintTable();
              renderDock();
            });
          });
        }, 140);
      });
    });

    function paintSlot(slot, product) {
      if (!slot) return;
      slot.classList.toggle("has-device", Boolean(product));
      slot.querySelector("[data-picked]").innerHTML = product
        ? `<div class="picked"><img src="${product.image || ""}" alt=""><div><strong>${escapeHtml(product.title)}</strong><div class="meta">${product.price_label || ""}</div></div><button type="button" class="slot-remove" data-slot-remove aria-label="Remove ${escapeHtml(product.title)}">×</button></div>`
        : "";
    }

    function paintTable() {
      const products = state.filter(Boolean);
      if (products.length < 2) {
        tableHost.innerHTML = `<p class="empty">Select 2 or 3 devices to compare specs side by side.</p>`;
        return;
      }
      const keys = new Set();
      products.forEach((p) => {
        Object.entries(p.specs || {}).forEach(([k, v]) => {
          if (v !== null && v !== undefined && String(v).trim() !== "") keys.add(k);
        });
      });
      const rows = [
        ...SPEC_ORDER.filter((key) => keys.has(key)),
        ...[...keys].filter((key) => !SPEC_ORDER.includes(key))
      ];
      tableHost.innerHTML = `<div class="compare-table-wrap"><table class="compare-table compare-table--${products.length}">
        <colgroup>
          <col class="compare-spec-col">
          ${products.map(() => `<col class="compare-device-col">`).join("")}
        </colgroup>
        <thead><tr><th class="compare-spec">Spec</th>${products
          .map(
            (p) =>
              `<th class="compare-device"><a class="compare-device-link" href="${p.url}"><img class="compare-device-img" src="${productImage(p)}" alt=""><span class="compare-device-name">${escapeHtml(p.title)}</span></a></th>`
          )
          .join("")}</tr></thead>
        <tbody>
          ${rows
            .map((key) => {
              const values = products.map((p) => (p.specs && p.specs[key]) || "—");
              const unique = new Set(values.filter((v) => v && v !== "—"));
              const isStory = STORY_KEYS.includes(key);
              const isCollapse = COLLAPSE_KEYS.includes(key);
              const isPrice = key === "Price";
              const isStock = key === "Stock";
              const cls = [
                unique.size > 1 && !isStory && !isPrice ? "diff" : "",
                isStory ? "compare-copy" : "",
                isCollapse ? "is-collapse" : "",
                isStock ? "stock-cell" : ""
              ]
                .filter(Boolean)
                .join(" ");
              return `<tr class="${isCollapse ? "compare-story-row" : ""}"><th class="compare-spec">${escapeHtml(key)}</th>${values
                .map((v) => {
                  let html = escapeHtml(v);
                  if (isPrice) html = v;
                  else if (isStory) html = escapeHtml(v).replace(/\n/g, "<br>");
                  if (isCollapse) {
                    const empty = !v || v === "—";
                    html = empty
                      ? "—"
                      : `<button class="compare-expand" type="button" aria-expanded="false"><span class="compare-expand-icon" aria-hidden="true">+</span><span class="compare-expand-label">Click to expand</span></button><div class="compare-expand-body" hidden>${html}</div>`;
                  }
                  return `<td class="${cls} ${isStock ? stockClass(v) : ""}">${html}</td>`;
                })
                .join("")}</tr>`;
            })
            .join("")}
        </tbody>
      </table></div>`;
      tableHost.querySelectorAll(".compare-expand").forEach((btn) => {
        btn.addEventListener("click", () => {
          const open = btn.getAttribute("aria-expanded") === "true";
          const body = btn.nextElementSibling;
          btn.setAttribute("aria-expanded", open ? "false" : "true");
          btn.querySelector(".compare-expand-icon").textContent = open ? "+" : "−";
          btn.querySelector(".compare-expand-label").textContent = open ? "Click to expand" : "Collapse";
          if (body) body.hidden = open;
        });
      });
    }

    function productImage(p) {
      const src = p.image || "";
      if (src.startsWith("//")) return `https:${src}`;
      return src;
    }
  }

  renderDock();
})();
